import type { ReactNode } from "react";

interface FacetFormFieldProps {
  label: string;
  error?: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}

export default function FacetFormField({ label, error, hint, children, className }: FacetFormFieldProps) {
  return (
    <div className={`flex min-w-0 flex-col gap-1.5 ${className ?? ""}`}>
      <label className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
        {label}
      </label>
      {children}
      {error && <span className="text-[10.5px] font-medium text-red-500">{error}</span>}
      {!error && hint && <span className="text-[10.5px] text-slate-400">{hint}</span>}
    </div>
  );
}

export const INPUT_CLASS =
  "w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-[13px] text-slate-800 shadow-sm transition placeholder:text-slate-400 hover:border-slate-300 focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-400/20";
